<template>
    <section class="section about-us" id="about">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="heading heading--primary">
                        <span class="heading__pre-title">About Us</span>

                        <h2 class="heading__title">
                            <span>Freedom to Wealth™</span>
                            <br /><span>is our mission</span>
                        </h2>
                    </div>

                    <p>
                        <strong>Contrary to very popular belief; Bitcoin was NOT designed to make anyone rich.</strong>
                    </p>

                    <p>
                        It's purpose and role is to <strong>free you</strong> from the constraints of a financial system working against you.
                        In 2017, Bitcoin Cash was realized; and with it, the economic tools needed to <strong>save money <em>(on fees);</em></strong> and in turn <strong>grow your own wealth.</strong>
                    </p>

                    <p>
                        Bitcoin Please was <strong>founded at the start of 2020,</strong> just ahead of the 3rd Bitcoin halving.
                        Our primary purpose is on <strong>educating</strong> as many people as possible on <strong>how to use these NEW econonic tools</strong> to build and sustain their own wealth, in the face of an impending global economic recession.
                    </p>

                    <a class="button button--primary" href="javascript://">
                        Learn more about us</a>
                </div>

                <div class="col-lg-6 col-xl-5 offset-xl-1">
                    <div class="info-box">
                        <img class="img--layout" src="@/assets/images/about_layout.png" alt="img"/>
                        <img class="img--bg" src="@/assets/images/about-us.jpg" alt="img"/>

                        <h4 class="info-box__title">Grow Your Own Wealth</h4>

                        <p>
                            Our community of dedicated volunteers are ready to stand by you and support your efforts for the long haul.
                        </p>

                        <p>
                            Building sustainable wealth doesn't happen overnight.
                            It will be up to YOU to put in the work to be successful.
                        </p>

                        <a class="info-box__link" href="javascript://">
                            Become a Wealth Volunteer</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        // msg: String
    }
}
</script>

<style scoped>
/*  */
</style>
